import React from "react";
import { NavLink } from 'react-router-dom';
import Header2 from '../../Common/Header2';
import Footer from '../../Common/Footer';
import About5 from './../../Elements/About5';
import Banner2 from './../../Elements/Banner2';
//import CommercialAlsoViewed from './../../Elements/CommercialAlsoViewed';
import ImageGallery from 'react-image-gallery';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Helmet } from "react-helmet"; 
import GetDesign from './../../Elements/GetDesign';
import Loader from "./../../Elements/Loader";
import WishList from './Wishlist'
import SimilarWishList from './SimilarWishList';
//config url
import configData from "./../../../config.js";
import '../../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

var url = `${configData.ADMIN_URL}/assets/images/banner/`;
//import AlsoViewed from './../Elements/AlsoViewed';


class CommercialDesignsDetail extends React.Component {

    constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoaded: false,
      isSearchActive: false,
      item: [],
      id: '',
      style: '',
      images: [],
      similar: [],
      alsoViewed: [],
      dynamic_fields: [],
      no_bathroom: true,
      no_bedroom : true,
      no_of_floors: true
      
    };
    }

     handleSearchToggle = () => {
        this.setState({ isSearchActive: !this.state.isSearchActive });
    };


    handleClick(id, e){

        fetch(`${configData.ADMIN_URL}/api/commercial-design/` + id)
          .then(res => res.json())
          .then(
            (result) => {
              this.setState({
                isLoaded: true,
                item: result.data,
                id: result.data.id,
                style: result.data.style,
                images: result.data.images,
                similar: result.similar,
                dynamic_fields: result.dynamic_data,
 
              });

              if(result.data[0].bedroom_count === 0 || result.data[0].bedroom_count === null) {
                 this.setState({
                  no_bathroom: false,       
                });
                
              }
              if(result.data[0].bathroom_count === 0 || result.data[0].bathroom_count === null) {
                this.setState({
                  no_bedroom: false,       
                });
                
              }
              if(result.data[0].floor_count === 0 || result.data[0].floor_count === null ) {
                this.setState({
                  no_of_floors: false,       
                });
                
              }
              
              
            },
            (error) => {
             this.props.history.push('/error-404');
             
            }
          )

        //alert(gid);
    }


        componentDidMount() {
          window.addEventListener("scroll", this.handleScroll);
          const {match} = this.props;
          //console.log(match.params.id);

          fetch(`${configData.ADMIN_URL}/api/commercial-design/` + match.params.id)
          .then(res => res.json())
          .then(
            (result) => {
              this.setState({
                isLoaded: true,
                item: result.data,
                id: result.data.id,
                style: result.data.style,
                images: result.data.images,
                similar: result.similar,
                dynamic_fields: result.dynamic_data,
              });

             

              if(result.data.bedroom_count === 0 || result.data.bedroom_count === null) {
                 this.setState({
                    no_bedroom: false,
                       
                });
                
              }
              if(result.data.bathroom_count === 0 || result.data.bathroom_count === null) {
                this.setState({
                    no_bathroom: false,       
                });
                
              }
              if(result.data.floor_count === 0 || result.data.floor_count === null ) {
                this.setState({
                  no_of_floors: false,       
                });
                
              }
              //console.log(result);
            },
            (error) => {
             this.props.history.push('/error-404');
             
            }
          )

        

    };


    handleScroll = (event) => {
      this.setState({
        scrollY: window.scrollY,
      });
    };

    render() {
       
        const { error, isLoaded, item, images, similar, isSearchActive, dynamic_fields } = this.state;
        let additionalComponents = "";

        if (this.state.scrollY > 10) {
        additionalComponents = (
          <>
              <Banner2 hTag="h3" />
                  <About5 page_content={item.footer_description} />
                <Footer />
           
          </>
        );
      }
        if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loader />
    } else {


          const similars = {
            loop: false,
            autoplay: false,
            center: false,
            items: 4,
            margin: 10,
            nav: false,
            dots: false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    items: 1.8,
                    margin: 15,
                },
                640: {
                    items: 1.8,
                    margin: 15
                },
                768: {
                    items: 1.8,
                    margin: 10
                },
                991: {
                    items: 4.5,
                    margin: 10
                },
                1200: {
                    items: 4
                }

            }
        };

        return (
            <>
            <Helmet>  
            <title>{item.meta_title}</title>
            <meta name="description" content={item.meta_description} />
            <meta name="keywords" content={item.meta_keywords} />
            <meta property="og:type" content="Page" />
            <meta property="og:title" content={item.meta_title} />
            <meta property="og:description" content={item.meta_description} />
            <meta property="og:url" content={window.location.href} />
            <link rel="canonical" href={configData.CANONICAL_URL+window.location.pathname.slice(1)} />
            <meta property="og:site_name" content={configData.SITE_NAME} />
            <link rel="canonical" href={configData.CANONICAL_URL+window.location.pathname.slice(1)} />
            </Helmet> 

            <Header2 />
                <div className="page-content">
                   
                    {/* SHOP SECTION START */}
                    <div className="section-full p-t80  bg-white mobile-page-padding">
                    
                        <div className="container woo-entry">
                            <div className="row mt-4">
                                <div className="col-md-6 col-sm-12 mtm-60">
                                <div className="single-product-title desktop-hidden">
                                    <div className="details_breadcrum pb-3 pt-2">
                                         Home {'>'} Readymade House {'>'}

                                          <span className="red fw-500"></span>
                                    </div>
                                    <h4 className="post-title"><NavLink to={"#"}>{item.title}</NavLink></h4>
                                </div>
                                <div className="text-right shareIcon d-none"><img alt="share" onClick={this.handleSearchToggle} src="/assets/images/share_black_24dp%20(1).svg" /></div>
                                    <div className="sx-box sx-product-gallery on-show-slider">
                                    <WishList id={item.id} item={item}  type={3} />
                                    <ImageGallery renderLeftNav={this.renderLeftNav} renderRightNav={this.renderRightNav} items={images} showPlayButton={false} />
                                     <i class="fa fa-expand image-expand" aria-hidden="true"></i>
                                    </div>
                                    <div className="wt-product-text mobile-hidden">
                                            <p className="text-justify mb-1 mt-3 border-style">
                                             <div className="single-product-title ">
                                             <h2 className="post-title mb-1 fs-custom"><NavLink to={"#"}>{item.short_description_title}</NavLink></h2>
                                        </div>
                                       

                                        <div dangerouslySetInnerHTML={ { __html: item.short_description ? item.short_description : '' } }></div>
                                           </p>
                                            
                                        </div>
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <div className="product-detail-info">
                                       
                                        <div className="single-product-title mobile-hidden">
                                        <h1 className="post-title pb-3 fs-1rem"><NavLink to={"#"}>{item.title}</NavLink></h1>
                                        </div>
                                        <div className="product-single-price">
                                             <div class="grid-2">
                                             <div class="cell-2 bl-0" id="1"><img alt="share" className="detailIcon" src="/assets/images/focus.svg" /> Plot Area <br />{item.width}</div>

                                            <div class="cell-2 " id="2"><img alt="share" className="detailIcon" src="/assets/images/repeat.svg" /> Plot Dimensions <br />{item.plot_size}</div>
                                            <div class="cell-2 bl-0 bb-0 mt-2" id="3"><i class="fa fa-building-o detailIcon red fs-30"></i>  Floor <br /> {item.floor_count}</div>
                                            <div class="cell-2 bb-0 pt-4" id="4 "><img  alt="share" className="detailIcon" src="/assets/images/comment-edit.svg" /> Style <br /> {item.style}</div>
                                          
                                          </div>
                                        </div>
                                        
                                          <GetDesign plan_no={item.design_code} />

                                        <div className=" mt-4">
                                             <div className="">
                                        <div class="">
                                        <h4 className="plan_details">Plan Details</h4>

                                        

                                          <div class="grid">

                                          {this.state.no_bedroom ? <div class="cell" id="1">Bedroom <br /> {item.bedroom_count}</div> : ''} 
                                           {this.state.no_bathroom ? <div class="cell" id="2">Bathroom <br /> {item.bathroom_count}</div> : ''} 
                                           {this.state.no_of_floors ? <div class="cell" id="3">Floor <br /> {item.floor_count}</div> : ''} 
                                            {dynamic_fields.map((item, index) => ( 
                                            <div class="cell" id="4">{item.name} <br /> {item.value}</div> 
                                           ))} 
                                            
                                           
                                          </div>
                                        </div>
                                           
                                        </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="wt-product-text desktop-hidden container">
                                            <p className="text-justify mb-1 mt-3 border-style">
                                             <div className="single-product-title ">
                                             <h2 className="post-title mb-1 fs-custom"><NavLink to={"#"}>{item.short_description_title}</NavLink></h2>
                                        </div>
                                        <div dangerouslySetInnerHTML={ { __html: item.short_description ? item.short_description : '' } }></div></p>
                                            
                                        </div>
                            </div>
                            
                           
                        </div>
                      
                
                    </div>
                       {similar.length > 0 ? <div className="section-full  p-b20  inner-page-padding">
                    <div className="container">
                        <div className="section-content">
                            {/* TITLE START */}
                             <div className="section-head">
                                 <div className="sx-separator-outer separator-left">
                               
                                    <h3 className="sep-line-one pb-0">Similar <span className='red'>Projects</span>  <img alt="share" className="w-3" src="/assets/images/Commercial-icon.svg"  /><NavLink to={`/commercial-designs`} className="bg-3e btn view_all float-right">View All</NavLink></h3>
                            
                            </div>
                            </div>
                            {/* TITLE END */}

                            <div className="work-carousel-outer">
                                <OwlCarousel className="owl-carousel   owl-btn-vertical-center" {...similars}>
                                    {similar.map((item, index) => (
                                         <div key={index} className=" m-b10  mm-b30">
                                                <div onClick={this.handleClick.bind(this, item.id)} className="sx-box sx-product-box overflow-hide shadow-cs">
                                                    {(`${item.tagline_color}` === 'yes') ? <div className="shop-pro-sale-bnr">Sale!</div> : ''}
                                                    <div className="sx-thum-bx ">
                                                        <NavLink  to={"/" + item.slug+"/126/"+item.id}>
                                                        <div  className="bg-contain bg-center h-200 bg-no-repeat" style={{ backgroundImage: `url('${url + item.primary_image}')` }} /></NavLink>
                                                        <div className="item-cart-view">
                                                            <div className="d-none item-cart-btn">
                                                                <NavLink to={"/" + item.slug+"/126/"+item.id}>
                                                                    <i className="fa fa-cart-plus" />
                                                                </NavLink>
                                                            </div>
                                                            <SimilarWishList id={item.id} item={similar} />
                                                        </div>
                                                    </div>
                                                    <div className="p-t10 pl-2 pr-2 text-left">
                                                        <h3 className="sx-title fsm-15 fs-16">
                                                        <NavLink onClick={this.handleClick.bind(this, item.id)} to={"/" + item.slug+"/126/"+item.id}>{item.title}</NavLink>
                                                        </h3>
                                                        <ul className=" m-b10 category_info dm-flex">
                                                            <li>
                                                                <i class="fa fa-expand"></i> {item.width} sqft
                                                            </li>
                                                            <li className="pl-20">
                                                                <i className="fa fa-building-o" />   {item.floor_count} 
                                                            </li>
                                                        </ul>
                                                        <p className="category_code_text">Code: {item.design_code} <NavLink onClick={this.handleClick.bind(this, item.id)} to={"/" + item.slug+"/126/"+item.id}><span className="float-right view_details mobile-hidden">View details</span><span className="float-right desktop-hidden"><i className="fa fa-eye"></i></span></NavLink></p>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                    ))}
                                </OwlCarousel>
                            </div>
                           
                        </div>
                    </div>
                </div>  : ''}
                        
                  

                       
                      
                    </div>
                    {/* SHOP SECTION END */}
                
               <div id="search" className={isSearchActive ? "open" : null}>
                <span className="close" onClick={this.handleSearchToggle}></span>
                <div class="mn-social-bottom-c" align="center">
                   <p>Share this:</p>
                   <a href="/#" class="mn-social-bottom"><i class="fa fa-facebook"></i></a>
                   <a href="/#" class="mn-social-bottom"><i class="fa fa-twitter"></i></a>
                   
                  <a href="/#" class="mn-social-bottom"><i class="fa fa-whatsapp"></i></a>
                   <a href="/#" class="mn-social-bottom"><i class="fa fa-pinterest-p"></i></a>
                  
                   
                </div>
            </div>
                {additionalComponents}
               
            </>
        );
     }
    };
};

export default CommercialDesignsDetail;